import { createSlice } from '@reduxjs/toolkit';
import { rgcLinkingState } from './types';
import { StoreStatus } from '../../core/types/common.types';
import { linkRGCBarcodeThunk } from './thunks';

// Initial State
const initialState: rgcLinkingState = {
  errors: null,
  status: StoreStatus.IDLE,
  response: null,
  isUpdated: null,
};

// Slice
export const rgcLinkingSlice = createSlice({
  name: 'rgcLinking',
  initialState,
  reducers: {
    reset: () => ({
      ...initialState,
    }),
  },
  extraReducers: (builder) => {
    builder.addCase(linkRGCBarcodeThunk.pending.type, (state) => {
      state.status = StoreStatus.BUSY;
      state.isUpdated = null;
    });
    builder.addCase(linkRGCBarcodeThunk.fulfilled.type, (state, action: any) => {
      state.status = StoreStatus.IDLE;
      state.response = action.payload;
      state.errors = null;
    });
    builder.addCase(linkRGCBarcodeThunk.rejected.type, (state, action: any) => {
      state.status = StoreStatus.ERROR;
      state.errors = action.payload;
      state.response = null;
    });
  },
});

// Action creators
export const { reset } = rgcLinkingSlice.actions;
export * from './thunks';
export * from './selectors';
export default rgcLinkingSlice.reducer;
